import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_API_URL, ENV } from "config/configUrl";
import InAppPaymentRequest from "./payment-request-in-app";

// The payer's page of a payment link. In production the admin renders it itself;
// elsewhere it is served by the Solutions API (/pay/link/<id>) and this route redirects there.
const RedirectToApiPaymentPage = () => {
  const { id } = useParams();
  useEffect(() => {
    if (id) window.location.replace(`${BASE_API_URL}/pay/link/${encodeURIComponent(id)}`);
  }, [id]);
  return null;
};

const PaymentRequest = () =>
  (ENV as string) === "production" ? <InAppPaymentRequest /> : <RedirectToApiPaymentPage />;

export default PaymentRequest;
